// modules/house-and-land/HouseAndLand.js
import React              from 'react';
import $                  from 'jquery';
import PageLoading        from '../PageLoading';
import PackageSearchBar   from './elements/PackageSearchBar';
import PackageSearchGrid from './elements/PackageSearchGrid';

import '../App.css';

var sources = require('../config.json');

class HouseAndLand extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.packagesearch_url = sources.packagesearch + "?ts=" + d.getTime();

		let view = 'grid';

		this.state = {
			view: view,
			data: {},
			packages: [],
			packagesFiltered: [],
			packagesSorted: [],
			sort: null,
			displayCount: 0
		};

		this.onSearchUpdate = this.onSearchUpdate.bind(this);
		this.onSearchReset = this.onSearchReset.bind(this);
		this.viewSwitcher = this.viewSwitcher.bind(this);
		this.filterByPrice = this.filterByPrice.bind(this);
		this.filterByArea = this.filterByArea.bind(this);
		this.filterByBedroom = this.filterByBedroom.bind(this);
		this.filterByFrontage = this.filterByFrontage.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
	}

	componentDidMount() {
		let packageSearch =  $.ajax({url: this.packagesearch_url,dataType:'json'});
		$.when(packageSearch).done(function(data) {
			let packagesFiltered = this.filterByHouseID(data.s_packages,'p_house_id');
			let newState = Object.assign(this.state, {
				data: data,
				packages: data.s_packages,
				packagesFiltered: packagesFiltered,
				packagesSorted: packagesFiltered,
				displayCount: 0
			});
			this.setState(newState);
		}.bind(this));
	}

	onSearchUpdate(data) {
		$('.btn__filter-search').addClass('searching-active');
		let packagesFiltered = this.state.packages;
		packagesFiltered = this.filterByPrice(data.price, packagesFiltered);
		packagesFiltered = this.filterByArea(data.area, packagesFiltered);
		packagesFiltered = this.filterByBedroom(data.bed, packagesFiltered);
		packagesFiltered = this.filterByFrontage(data.frontage, packagesFiltered);
		packagesFiltered = this.filterByHouseID(packagesFiltered,'p_house_id');
		let newState = Object.assign(this.state, {
			packagesFiltered: packagesFiltered,
			packagesSorted: packagesFiltered
		});
		this.setState(newState);

		setTimeout(() => { $('.btn__filter-search').removeClass('searching-active'); }, 1000);
	}

	onSearchReset() {
		let packagesFiltered = this.filterByHouseID(this.state.packages,'p_house_id');
		if(this.state.sort !== null) {
			let newState = Object.assign(this.state, {
				packagesFiltered: packagesFiltered
			});
			this.setState(newState);
			this.onSortUpdate(this.state.sort.type, this.state.sort.direction);
		} else {
			let newState = Object.assign(this.state, {
				packagesFiltered: packagesFiltered,
				packagesSorted: packagesFiltered
			});
			this.setState(newState);
		}
	}

	filterByHouseID(packages,key) {
		let visited = [];
		let p = packages.map(item => {
			if(item.hasOwnProperty(key)) {
				if(visited.indexOf(item[key]) < 0) {
					visited.push(item[key]);
					return item[key];
				}
			} else {
				return null;
			}
		}).filter(item => item !== null && item !== undefined).map(id => packages.filter(pkg => pkg.p_house_id === id).shift());
		return p;
	}

	filterByPrice(price, packages) {
		return packages.reduce(function (accum, thisPackage) {
			if (Number(thisPackage.p_price) >= price.start && Number(thisPackage.p_price) <= price.end)
				accum.push(thisPackage);
			return accum;
		}, []);
	}

	filterByArea(area, packages) {
		return packages.reduce(function (accum, thisPackage) {
			if (Number(thisPackage.l_area) >= area.start && Number(thisPackage.l_area) <= area.end)
				accum.push(thisPackage);
			return accum;
		}, []);
	}

	filterByBedroom(bed, packages) {
		return packages.reduce(function (accum, thisPackage) {
			if (Number(thisPackage.p_beds) >= bed.start && Number(thisPackage.p_beds) <= bed.end)
				accum.push(thisPackage);
			return accum;
		}, []);
	}

	filterByFrontage(frontage, packages) {
		return packages.reduce(function (accum, thisPackage) {
			if (Number(thisPackage.l_frontage) >= frontage.start && Number(thisPackage.l_frontage) <= frontage.end)
				accum.push(thisPackage);
			return accum;
		}, []);
	}

	viewSwitcher() {
		if(this.state.packagesSorted.length === 0) {
			return ( <p className="no-packages">No search results found matching your criteria.</p> )
		}
		if (this.state.view === 'grid') {
			return ( <PackageSearchGrid data={this.state.packagesSorted}/> )
		}
	}

	render() {
		if (typeof this.state.data.s_packages !== "undefined") {
			return (
				<div className="App">
					<div className="outer-site-plans">
						<div className="inner-site-plans">
							<h1 className="masterplan-title">House and Land</h1>
							<div className="HLContainer">
								<div className="HLFormContainer">
									<PackageSearchBar onSearchClick={this.onSearchUpdate} onResetClick={this.onSearchReset} search={this.props.location.query}/>
								</div>
								<div className="clear-div"/>
							</div>
							<div className="all-ipackage-container">
								{this.viewSwitcher()}
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div>
					<PageLoading>House and Land</PageLoading>
				</div>
			)
		}
	}
}

export default HouseAndLand;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/HouseAndLand.js
 **/